import * as React from 'react';
// import PropTypes from 'prop-types';

import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
// import Divider from '@mui/material/Divider';
import { ThemeProvider, createTheme } from '@mui/material/styles';
// import ToggleButton from '@mui/material/ToggleButton';
// import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
// import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import NavBar from '../components/NavBar';
import Hero from '../components/Hero';
// import LogoCollection from '../components/LogoCollection';
// import Highlights from '../components/Highlights';
// import Pricing from '../components/Pricing';
// import Features from '../components/Features';
// import Testimonials from '../components/Testimonials';
import List from '../components/List';
import Footer from '../components/Footer';
// import getLPTheme from '../getLPTheme';
import { alpha } from '@mui/material';

// function ToggleCustomTheme({ showCustomTheme, toggleCustomTheme }) {
//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         width: '100dvw',
//         position: 'fixed',
//         bottom: 24
//       }}>
//       {/* <ToggleButtonGroup
//         color="primary"
//         exclusive
//         value={showCustomTheme}
//         onChange={toggleCustomTheme}
//         aria-label="Platform"
//         sx={{
//           backgroundColor: 'background.default',
//           '& .Mui-selected': {
//             pointerEvents: 'none',
//           },
//         }}
//       >
//         <ToggleButton value>
//           <AutoAwesomeRoundedIcon sx={{ fontSize: '20px', mr: 1 }} />
//           Custom theme
//         </ToggleButton>
//         <ToggleButton value={false}>Material Design 2</ToggleButton>
//       </ToggleButtonGroup> */}
//     </Box>
//   );
// }

// ToggleCustomTheme.propTypes = {
//   showCustomTheme: PropTypes.shape({
//     valueOf: PropTypes.func.isRequired,
//   }).isRequired,
//   toggleCustomTheme: PropTypes.func.isRequired,
// };

export default function CaseList() {
  const [mode, setMode] = localStorage.getItem('colourMode')
    ? React.useState(localStorage.getItem('colourMode'))
    : React.useState('light');
  // const [showCustomTheme, setShowCustomTheme] = React.useState(true);
  // const LPtheme = createTheme(getLPTheme(mode));
  const defaultTheme = createTheme({ palette: { mode } });

  const toggleColorMode = () => {
    setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  const isLoggedIn = localStorage.getItem('accessToken');
  if (!isLoggedIn) {
    window.location.href = '/sign-in';
  }

  // const toggleCustomTheme = () => {
  //   setShowCustomTheme((prev) => !prev);
  // };

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <NavBar mode={mode} toggleColorMode={toggleColorMode} />
        <Box
          sx={(theme) => ({
            width: '100%',
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundImage:
              theme.palette.mode === 'light'
                ? 'linear-gradient(0deg, #CEE5FD, #FFF)'
                : `linear-gradient(0deg, #02294F, ${alpha('#090E10', 0.0)})`,
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat'
          })}>
          <List />
          <Footer />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
